/**
 * Step shocks by month — signups, MRR, conversion (W4).
 */

/**
 * @param {Array<object>} events
 * @param {number} monthIndex
 * @returns {{ deltaSignups: number, mrrShock: number, conversionDeltaPp: number, churnDeltaPp: number, cashInjection: number, labels: string[] }}
 */
export function applyEvents(events, monthIndex) {
  const applicable = (events || []).filter((e) => Number(e.monthIndex) === monthIndex);
  return applicable.reduce(
    (acc, ev) => ({
      deltaSignups: acc.deltaSignups + numberOrZero(ev.deltaSignups),
      mrrShock:
        acc.mrrShock +
        (ev.type === 'churn' || ev.type === 'cash_injection'
          ? 0
          : numberOrZero(ev.mrrShock)),
      conversionDeltaPp:
        acc.conversionDeltaPp +
        (ev.type === 'churn' || ev.type === 'cash_injection'
          ? 0
          : numberOrZero(ev.conversionDeltaPp)),
      churnDeltaPp:
        acc.churnDeltaPp +
        (ev.type === 'churn' ? numberOrZero(ev.churnDeltaPp) : 0),
      cashInjection:
        acc.cashInjection +
        (ev.type === 'cash_injection'
          ? numberOrZero(ev.amount ?? ev.cashInjection)
          : 0),
      labels: ev.label ? [...acc.labels, ev.label] : acc.labels,
    }),
    {
      deltaSignups: 0,
      mrrShock: 0,
      conversionDeltaPp: 0,
      churnDeltaPp: 0,
      cashInjection: 0,
      labels: [],
    }
  );
}

function numberOrZero(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * @param {Array<object>} events
 * @param {number} index
 * @param {object} patch
 */
export function updateEvent(events, index, patch) {
  return events.map((ev, i) => {
    if (i !== index) return ev;
    const next = { ...ev, ...patch };
    if (patch.type && patch.type !== ev.type) {
      if (patch.type === 'cash_injection') {
        next.deltaSignups = 0;
        next.mrrShock = 0;
        next.conversionDeltaPp = 0;
        next.churnDeltaPp = 0;
        next.amount = 0;
        next.cashInjection = 0;
      } else if (patch.type === 'churn') {
        next.deltaSignups = 0;
        next.mrrShock = 0;
        next.conversionDeltaPp = 0;
        next.amount = 0;
        next.cashInjection = 0;
      } else {
        next.churnDeltaPp = 0;
        next.amount = 0;
        next.cashInjection = 0;
      }
    }
    return next;
  });
}

export function addEvent(events, event = {}) {
  return [
    ...(events || []),
    {
      monthIndex: 3,
      type: 'launch',
      label: 'New event',
      deltaSignups: 0,
      mrrShock: 0,
      conversionDeltaPp: 0,
      churnDeltaPp: 0,
      cashInjection: 0,
      amount: 0,
      ...event,
    },
  ];
}

export function removeEvent(events, index) {
  return events.filter((_, i) => i !== index);
}

export const EVENT_TYPES = [
  { value: 'launch', label: 'Product launch' },
  { value: 'campaign', label: 'Marketing campaign' },
  { value: 'pricing', label: 'Pricing change' },
  { value: 'churn', label: 'Churn spike' },
  { value: 'cash_injection', label: 'Cash injection (raise)' },
  { value: 'other', label: 'Other' },
];
